export default __webpack_public_path__ + "static/media/center-building.fd61b52c.svg";